<template>
  <div class="header-content">
      <v-row class="row-menu" >
        <menu-base />
    </v-row>
  </div>
</template>

<script>

import MenuBase from '@/components/elements/MenuBase.vue'

export default {
  name: 'Header',
  props: {
    msg: String,
    item: Object
  },
  data() {
    return {    
      openOnHover: true,  
    };
  },
  components: {
    MenuBase,
  },
  methods: {
    triggerClick: function (route){
      this.$router.go(route);
    },
  },
  computed: {
    rutas () {
      return this.$router.options.routes;
    },
    menu () {
      return this.$store.getters.menu
    },
    logoAnimation() {
      const logo = this.logo.split()
      return logo
    },
    requestAnimation(){
      var item = document.getElementByClass('LineUP')
      item.animate([
        {left: '230px'}
      ],
      {
        duration: 3000,
        easing: 'ease-in_out',
        iterations: 'alternate',
        fill: 'forwards'
      })
      return item
    }
  }
}
</script>

<style scoped lang="scss">

.menu-principal {
  text-transform: capitalize;
  color: rgb(5, 109, 141) !important;
}

.menu {
  width: 100%;
  justify-content: center;
  display: flex;
  margin: -2px 5px 1px;
  padding: 12px 0 8px 0;

  & ul { display: flex; flex-flow: row;}
  
  & ul.second-level { 
    position: absolute;
    flex-flow: column;
    justify-content: left;
    background: white;
    width: 500px;
    display: inline-flex;

    li {
      width: 200px;

      a {
        background: none;
      }
    }
  }

  &-link a {
    font-size: .7em;
    margin: 0 5px;
    padding: 5px 15px;
    color: rgb(48, 47, 47); 
    border-radius: 5px 5px 0 0; 
    text-decoration: none;
    position: relative;
    z-index: 10;
    border: 2px solid #ffffff;
    border-bottom: 0;

    &:hover, &.active{
      color: rgb(29, 29, 29); 
      border: 2px solid #59a6fd;
      border-bottom: 0;
    }
    &.noactive {
      color: rgb(0, 0, 0); 
      background: #59a6fd; 
    }
  }
}

.submenu {
  margin-top: 0px;
}

.logo {
  text-align: center;
}

.dropdown {
  visibility: hidden;
  opacity: 0;
  transition: all 200ms linear;
  transform: translatex(-50%) rotatex(90deg) scale(0);

  &.open {
    transform: translatex(-50%);
    visibility: visible;
    opacity: 1;
    display: flex;
  }
}

.link-logo {
    margin: 0px 0 0 0;
}

.letter { padding: 5px }

h1 {
  margin: 40px;
  text-align: left;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

/* .introLogo {
      display: flex !important;
      justify-content: center !important;
      align-content: center !important; 
      z-index: 5;
      position:sticky;
      width: 100%;
      height: 110px;
      background: #ffdd229c;
      background: -moz-linear-gradient(to right, #ffdd229c, #e18727);
      background: linear-gradient(to left, #ffdd229c, #e18727);
      position: -webkit-sticky;
      position: sticky;
      top: 0;
}
 */
</style>
